import { InteractiveContainer } from "@jugl-web/ui-components";
import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { EntityInvitationModel } from "@jugl-web/rest-api";
import { EntityInvitationCard } from "@web-src/modules/entities/components/EntityInvitationCard";

interface CXInvitationsListProps {
  invitations: EntityInvitationModel[];
  onAccepted: (entityId: string) => void;
  onCreateWorkspace: () => void;
}

export const CXInvitationsList: React.FC<CXInvitationsListProps> = ({
  invitations,
  onAccepted,
  onCreateWorkspace,
}) => {
  const { t } = useTranslations();

  return (
    <div className="my-auto flex w-[566px] flex-col items-center justify-center gap-6 py-4">
      <span className="text-dark font-secondary text-[32px] font-medium leading-[48px]">
        {t({
          id: "cx-invitations-page.youve-been-invited",
          defaultMessage: "You've been invited!",
        })}
      </span>
      <span className="text-grey-900 font-secondary text-sm leading-4">
        {t({
          id: "cx-invitations-page.select-workspace-to-join",
          defaultMessage: "Select a workspace below to join and get started.",
        })}
      </span>
      <div className="jugl__custom-scrollbar flex max-h-[300px] w-full flex-col gap-3 overflow-y-auto">
        {invitations.map((invitation) => (
          <EntityInvitationCard
            key={invitation.id}
            invitation={invitation}
            disableDelete
            onInvitationAcceptedSuccess={() => onAccepted(invitation.entityId)}
          />
        ))}
      </div>
      <InteractiveContainer
        className="text-primary-600 font-secondary mt-2 text-sm underline"
        onClick={onCreateWorkspace}
      >
        {t({
          id: "cx-invitations-page.create-new-workspace",
          defaultMessage: "Or create a new workspace",
        })}
      </InteractiveContainer>
    </div>
  );
};
